import { ReviewTemplate } from 'types'
import { reviewTemplateKeys } from './reviewTemplateKeys'
import { QueryOptions } from 'api/clients/InformalFeedbackRequestsClient'
import { useInfiniteQuery } from 'react-query'
import { Response, SuccessResponse } from 'request-dot-js'
import { getNextPageParam } from 'utils/getNextPageParam'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'

interface UseReviewTemplatesProps {
  workspaceId: number
  queryOptions?: QueryOptions
}

const defaultQueryOptions: QueryOptions = {}

type ReviewTemplatesView = {
  review_templates: ReviewTemplate[]
}

const ITEMS_PER_PAGE = 20

export const useReviewTemplates = ({ workspaceId, queryOptions = defaultQueryOptions }: UseReviewTemplatesProps) => {
  return useInfiniteQuery<Response<ReviewTemplatesView>>(
    reviewTemplateKeys.list(workspaceId),
    async ({ pageParam = 1 }): Promise<SuccessResponse<ReviewTemplatesView>> => {
      const searchParams = new URLSearchParams({ page: pageParam.toString(), items: ITEMS_PER_PAGE.toString() })
      const res = await sendToApi<ReviewTemplatesView>(`/w/${workspaceId}/review_templates?${searchParams.toString()}`)
      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error()
      return res
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 3,
      getNextPageParam,
      ...queryOptions,
    },
  )
}
